module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-nine2.a5b89af0.png";